/** @deprecated Import from `@cornerstonejs/metadata` instead. */
import { utilities } from '@cornerstonejs/metadata';

const {
  getPixelSpacingInformation,
  calculateRadiographicPixelSpacing,
  getERMF,
} = utilities;

export {
  getPixelSpacingInformation,
  calculateRadiographicPixelSpacing,
  getERMF,
};
export default utilities.getPixelSpacingInformation;
